/**
* WebAuthHandler.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
import { _throwInternal, getDocument } from "@microsoft/applicationinsights-core-js";
import { AuthType } from "./Enums";
import { RequestHandler } from "./RequestHandler";
var WebAuthHandler = /** @class */ (function () {
    function WebAuthHandler(endpointUrl, authType, logger) {
        this._endpointUrl = "";
        this._logger = logger;
        this._endpointUrl = endpointUrl;
        this._requestHandler = new RequestHandler();
        this.setAuthType(authType);
    }
    /**
    * Set auth type and clen authHandler is already started
    * @param authType - The authentication method.  1-MSA, 2-AAD.
    */
    WebAuthHandler.prototype.setAuthType = function (authType) {
        var authTypeResource = "";
        switch (authType) {
            case AuthType.AAD:
                authTypeResource = "aad.js";
                break;
            case AuthType.MSA:
                authTypeResource = "msa.js";
                break;
        }
        this._getLoginUrlPath = this._endpointUrl + "auth/GetLoginUrl/" + authTypeResource;
        this._signOutPath = this._endpointUrl + "auth/SignOut/" + authTypeResource;
    };
    /**
    * Start auth handhshake process using iframe
    */
    WebAuthHandler.prototype.startAuthHandshake = function () {
        var _this = this;
        this._requestHandler.makeRequest(this._getLoginUrlPath, "", "GET", function (status, responseBody, headers) {
            try {
                var json = JSON.parse(responseBody);
                var loginUrl = json.webResult.authLoginUrl;
                var doc = getDocument();
                if (doc) {
                    // Create iframe
                    var loginIframe = doc.createElement("iframe");
                    var randomNumber = Math.floor(Math.random() * Math.floor(10000));
                    loginIframe.id = "telframe" + randomNumber;
                    loginIframe.style.display = "none";
                    loginIframe.src = loginUrl;
                    doc.body.appendChild(loginIframe);
                    _this._loginIframeId = loginIframe.id;
                }
            }
            catch (e) {
                _throwInternal(_this._logger, 1 /* eLoggingSeverity.CRITICAL */, 501 /* _eExtendedInternalMessageId.AuthHandShakeError */, "Error with auth handshake process: " + e);
            }
        });
    };
    /**
    * Remove auth handhsake iframe from DOM
    */
    WebAuthHandler.prototype.cleanAuthIFrame = function () {
        // Remove auth iFrame if present
        var doc = getDocument();
        if (doc) {
            var authIframe = doc.getElementById(this._loginIframeId);
            if (authIframe) {
                doc.body.removeChild(authIframe);
            }
        }
    };
    /**
    * Sign out and remove 1DS server auth cookies
    */
    WebAuthHandler.prototype.signOutAndClearCookies = function () {
        this._requestHandler.makeRequest(this._signOutPath, "", "POST", function (status, responseBody, headers) {
            // Cookies deleted
        });
    };
    return WebAuthHandler;
}());
export { WebAuthHandler };
//# sourceMappingURL=WebAuthHandler.js.map